import React from 'react'
import clsx from 'clsx'
import styles from './style.module.scss'

export default function ReportsCard({ title, value, percent, sub, note, onClick, active, actionLabel }) {
	const content = (
		<>
			<div className={styles.title}>{title}</div>
			<div className={styles.value}>{value}</div>
			{percent && <div className={styles.percent}>{percent}</div>}
			{sub && <div className={styles.sub}>{sub}</div>}
			{note && <div className={styles.note}>{note}</div>}
		</>
	)

	if (!onClick) return <div className={styles.root}>{content}</div>

	// Anklickbare Kachel: ein Knopf, damit sie auch per Tastatur erreichbar ist.
	return (
		<button
			type="button"
			className={clsx(styles.root, styles.clickable, active && styles.active)}
			onClick={onClick}
			aria-pressed={Boolean(active)}
			title={actionLabel}
		>
			{content}
		</button>
	)
}
